export const FEATURES = "Features";
export const USECASES = "Values";
export const PRICING = "Pricing";
export const PRICINGPLAN = "Pricing & Plans";
export const PLAN = "Plans";
export const FAQS = "FAQs";
export const CONTACT = "Contact";
export const CONTACTUS = "Contact Us";
export const HEADER_TITLE1 = "Uni";
export const HEADER_TITLE2 = "Comply.ai";
export const SIGNIN = " Sign In";
export const SIGNOUT = "Sign Out";
export const SIGNUP = "Sign Up";
export const BODYTITLE = "Compliance HUB";
export const BODYTITLE1 = "Simplifying Healthcare Governance ";
export const BODYSUBTITLE =
  "Centralize compliance data to save costs, reduce staff time burden and mitigate organizational risks";
export const AVIATION_BODYTITLE = "Compliance HUB";
export const AVIATION_BODYTITLE1 = "Simplifying Aviation Governance";
export const AVIATION_BODYSUBTITLE =
  "Centralize FAA Part 21, 135, and 139 compliance data to reduce audit prep time and operational risk";
export const GET_STARTED = "Get Started";
export const FEATURE_TITLE = "Everything You Need to";
export const FEATURE_TITLE1 = " Stay";
export const FEATURE_TITLE2 = " Compliant";
export const COMPLIANCE_TITLE = "Compliance Explorer";
export const COMPLIANCE_DESC =
  "Navigate HIPAA, OSHA, CFR 492 and more regulations with real-time updates";
export const AVIATION_COMPLIANCE_TITLE = "Compliance Explorer";
export const AVIATION_COMPLIANCE_DESC =
  "Navigate FARs, Ops Specs, and airport certification rules with real-time updates";
export const REGULATION_TITLE = "Federal and State Regulations";
export const REGULATION_DESC =
  "Centralized access to federal and state-specific compliance rules";
export const AVIATION_REGULATION_TITLE = "FAA & Airport Regulations";
export const AVIATION_REGULATION_DESC =
  "Centralized access to Part 21, 135, 139 and related aviation requirements";
export const PENALTY_TITLE = "Penalties Tracker";
export const PENALTY_DESC =
  "Stay up to date on compliance penalties and track state-specific requirements";
export const AVIATION_PENALTY_TITLE = "Enforcement Tracker";
export const AVIATION_PENALTY_DESC =
  "Stay current on FAA enforcement actions and certificate-related risk";
export const TRAINING_TITLE = "Training Assignments";
export const TRAINING_DESC =
  "Automate, schedule, and monitor staff compliance certifications";
export const AVIATION_TRAINING_TITLE = "Training Assignments";
export const AVIATION_TRAINING_DESC =
  "Automate, schedule, and monitor crew and staff compliance certifications";
export const POLICY_TITLE = "Policy Templates";
export const POLICY_DESC =
  "Access pre-built, customizable policies for all accreditations like RHC, FQHC and more";
export const AVIATION_POLICY_TITLE = "Manual & Policy Templates";
export const AVIATION_POLICY_DESC =
  "Access pre-built, customizable manuals and policies for Part 21, 135, and 139 operators";
export const AUDITOR_TITLE = "Survey";
export const AUDITOR_DESC =
  "Simplify mock survey preparations to ensure always ready for real survey";
export const AVIATION_AUDITOR_TITLE = "Inspection Ready";
export const AVIATION_AUDITOR_DESC =
  "Simplify mock inspection prep so your operation stays certificate-ready";
export const USECASE_TITLE = "Why It Matters";
export const COST_TITLE1 = "HIPAA, OSHA, NIST, NCQA violations can cost up to ";
export const COST_TITLE2 = "$1.5M ";
export const COST_TITLE3 = "annually";
export const AVIATION_COST_TITLE1 =
  "Certificate actions, civil penalties, and grounding risk can cost up to ";
export const AVIATION_COST_TITLE2 = "$1.5M ";
export const AVIATION_COST_TITLE3 = "annually";
export const COMPLIANCEDETAIL = "Missed deadlines = increased risk exposure";
export const TRAININGDETAIL =
  "Administrative burden reduced by more than 60% to improve focus on patient care";
export const AVIATION_COMPLIANCEDETAIL =
  "Missed obligations = increased certificate and operational risk";
export const AVIATION_TRAININGDETAIL =
  "Administrative burden reduced by more than 60% so teams stay focused on safe operations";
export const COPYRIGHT = "2026 – AffableONE Inc., All Rights Reserved.​";
export const LOCATION = "Washington, USA";
export const ANNUALLY = "Annually";
export const MONTHLY = "Monthly";
export const MOSTPOPULAR = "Most Popular";
export const FAQ_DESC = "Frequently Asked Questions";
export const CONTACTUS_TITLE1 = "Let's Make Compliance Simple. Together";
export const CONTACTUS_TITLE2 = "Get in touch with us";
export const CONTACTUS_TITLE3 =
  "Have questions or want early access? Reach out and we'll get back to you shortly.";
export const FIRSTNAME = "First name";
export const LASTNAME = "Last name";
export const EMAIL = "Email";
export const MESSAGE = "Message";
export const LETSTALK = "Let's talk";
